import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'recompose'
import { accessVerification as accessVerificationApi } from 'redux/modules/api'
import { get } from 'lodash'
import { notification } from 'redux/modules/app'

function decorator() {
  return ComposedComponent => {
    const enhance = compose(
      withRouter,
      connect(
        ({ api, auth }) => ({
          accessVerification: api.accessVerification.verifyAccess,
          user: get(auth, 'user')
        }),
        {
          notification,
          ...accessVerificationApi
        }
      )
    )

    class AccessVerification extends Component {
      static propTypes = {
        user: PropTypes.object,
        intl: PropTypes.object,
        verifyAccess: PropTypes.func.isRequired,
        sendVerificationCodeToEmail: PropTypes.func.isRequired,
        notification: PropTypes.func
      }

      handleVerifyAccess = (authorizationCode, verificationCode) => {
        this.props.verifyAccess(authorizationCode, verificationCode).then(result => {
          if (result.body.authorized === false) {
            this.props.notification('Incorrect verification code', {
              intlKey: 'notifications.incorrect_verification_code',
              status: 'error'
            })
          }
        })
      }

      handleSendVerificationCodeToEmail = authorizationCode => {
        this.props.sendVerificationCodeToEmail(authorizationCode).then(result => {
          if (result.body.validUntil) {
            this.props.notification('Verification code sent successfully', {
              intlKey: 'notifications.verification_code_sent_successfully',
              status: 'success'
            })
          } else {
            this.props.notification('Failed to send verification code', {
              intlKey: 'notifications.failed_to_send_verification_code',
              status: 'error'
            })
          }
        }).catch(error => {
          if (get(error, 'body.errorCode') === 'AUTH_CODE_EXPIRATED') {
            return this.props.notification('Authorization code has expired', {
              status: 'error',
              intlKey: 'notifications.authorization_code_has_expired'
            })
          }

          this.props.notification('Failed to send verification code', {
            intlKey: 'notifications.failed_to_send_verification_code',
            status: 'error'
          })
        })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            verifyAccess={this.handleVerifyAccess}
            sendVerificationCodeToEmail={this.handleSendVerificationCodeToEmail}
          />
        )
      }
    }
    return enhance(AccessVerification)
  }
}

export default decorator
